import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AuthService } from '../../../../system/auth.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FileUploader } from 'ng2-file-upload';
import { UploadService } from '../../../../api/Services/common/upload.service';
import { CourseService } from '../../../../api/Services/maintenance/course.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DialogService } from '../../../../common/dialog.service';
import {  BASE_URL_UPLOAD,BASE_URL_DOWNLOAD } from '../../../../app.service';
import { MovieService } from '../../../../api/Services/maintenance/movie.service';
//const URL = 'http://localhost:3000/api/upload';

@Component({
  selector: 'app-courses-add',
  templateUrl: './courses-add.component.html',
  styleUrls: ['./courses-add.component.css']
})
export class CoursesAddComponent implements OnInit {
 
  public textoedicion: string = 'Registro';
  public parameters: any[];
  public ListContentCourses: any[];
  public moduleList: any[];
  public movieList: any[];
  public default_select_module: number;

  @Input() data;

  public editActivo = false;
  public isEditable = false;

  isLinear = true;
  InformationGeneral: FormGroup;
  selectedContentCourses: number;

   

 
  uploader:FileUploader;
 
  response:string;

  count:number = 1;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private courseServices: CourseService,
    private toastr: ToastrService,
    private uploadServices: UploadService,
    private dialogService: DialogService,
    private movieServices: MovieService

  ) { 
 
  }

  ngOnInit(): void {
    this.LoadInitial();
    this.initForm();
    console.log(this.data.tabData.element);
    if (this.data.tabData.element) {
      this.InformationGeneral.setValue(this.data.tabData.element);
      if (this.InformationGeneral.controls['cou_in_id'].value > 0) {
        this.editActivo = true;
 
       
      }

    }

     
    
    
   

  }



  public initForm() {
    this.InformationGeneral = this.formBuilder.group({
      cou_in_id: [null],
      cou_in_category: ['', Validators.required],
      cou_vc_category: [null],
      cou_vc_name: [null, Validators.required],
      cou_vc_name_short: [null],
      cou_tx_description: [null, Validators.required],
      cou_tx_learn: [null, Validators.required],
      cou_tx_addressed: [null, Validators.required],
      cou_in_duration_type: ['', Validators.required],
      cou_vc_duration_type: [''],
      cou_in_duration: [null, Validators.required],
      cou_vc_duration: [''],
      cou_in_payment_method: [null],
      emp_bi_id: [null],
      cou_do_soles_cost: [null, Validators.required],
      cou_do_dollar_cost: [null, Validators.required],
      cou_in_status: [null],
      cou_vc_status: [null],
      cou_vc_uri_folder:[null]
    });
  }

  public LoadInitial() {
    this.parameters = this.authService.getParameters();
  }

  LoadDataModule(e) {
    console.log("CURSO");
    console.log(e);
    this.moduleList = e;

    if (e != null) {
      if (e.length > 0) {
        this.default_select_module = e[0].mod_in_id;
      }
    }

     

  }


  

  public NextCourses() {
    if (this.editActivo == true) {
      this.Update();
    }
    else {
      this.Save();
    }
  }

  /* COURSES */
  Save() {
    //emp_bi_id
    this.InformationGeneral.controls['emp_bi_id'].setValue(this.authService.getEmployeeID());
    this.courseServices.Insert(this.InformationGeneral.getRawValue()).subscribe(
      data => {
       
        if (data['sucess']) {
         
          let result = data['data'][0];
          console.log(result);
          this.InformationGeneral.controls['cou_in_id'].setValue(result.ID);
          this.InformationGeneral.controls['cou_vc_uri_folder'].setValue(result.cou_vc_uri_folder);
          
          console.log(this.InformationGeneral.getRawValue());

          

          //  this.LoadModule();
          //  this.toastr.success(data['msg'], 'Correcto');
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );
  }
  Update(){
    this.InformationGeneral.controls['emp_bi_id'].setValue(this.authService.getEmployeeID());
    console.log(this.InformationGeneral.getRawValue());
    this.courseServices.Update(this.InformationGeneral.getRawValue()).subscribe(
      data => {
        console.log(data);
       
        if (data['sucess']) {
          let result = data['data'][0];
          console.log(result);
          console.log(this.InformationGeneral.getRawValue());
          //this.InformationGeneral.controls['cou_vc_name_folder'].setValue(result.cou_vc_name_folder);
           
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }

      }
    );

  }
 
 


}

